import { render } from "./MaterialLoadingWithoutAnimation.vue?vue&type=template&id=a70c7440&scoped=true"
import script from "./MaterialLoadingWithoutAnimation.vue?vue&type=script&lang=js"
export * from "./MaterialLoadingWithoutAnimation.vue?vue&type=script&lang=js"

import "./MaterialLoadingWithoutAnimation.vue?vue&type=style&index=0&id=a70c7440&scoped=true&lang=css"

import exportComponent from "/var/www/html/online-ordering/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a70c7440"]])

export default __exports__